import { NameFieldValue } from "../..";
import { useColors } from "../colors/useColors";
import { AvatarProps } from "./Avatar";
import { useMemo } from "react";

export function useAvatar(props: AvatarProps) {
  const {
    imageSrc,
    iconClassName,
    imageAltText = "Avatar Image",
    subText = "",
    size = "large",
    firstAndLastName,
    fullName,
    avatarBgColor,
    avatarFaIcon,
    avatarShape = "Circle",
    style,
    textColor,
    showFullName = false,
  } = props;

  const { getColorForName } = useColors();

  let effectiveFirstAndLastName: NameFieldValue | undefined = firstAndLastName;

  if (!firstAndLastName && fullName) {
    const parts = fullName.split(" ");
    effectiveFirstAndLastName = {
      firstName: parts[0],
      lastName: parts.length > 1 ? parts[parts.length - 1] : "",
    };
  }

  const bgColor = getColorForName(effectiveFirstAndLastName);

  let borderRadius: string;
  if (avatarShape === "Circle") {
    borderRadius = "50%";
  } else {
    borderRadius = "5%";
  }
  const background = avatarBgColor || bgColor || "#f5f6fa";
  const avatarStyleObj = {
    background,
    borderRadius,
  };
  const avatarClass = `ucl-avatar e-avatar e-avatar-${size}`;

  const contentStyle = useMemo(
    () => ({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 700,
      color: textColor || "#fff",
      width: "100%",
      height: "100%",
    }),
    [textColor]
  );

  let initials = useMemo(() => {
    if (
      effectiveFirstAndLastName &&
      typeof effectiveFirstAndLastName.firstName === "string" &&
      typeof effectiveFirstAndLastName.lastName === "string"
    ) {
      const firstInitial = (
        effectiveFirstAndLastName.firstName?.[0] ?? ""
      ).toUpperCase();
      const lastInitial = (
        effectiveFirstAndLastName.lastName?.[0] ?? ""
      ).toUpperCase();
      return `${firstInitial}${lastInitial}`;
    }
    return "";
  }, [effectiveFirstAndLastName]);

  const circleText = props.circleText || initials;

  const rightSideContent = useMemo(() => {
    if (showFullName && effectiveFirstAndLastName) {
      const nameParts = [
        effectiveFirstAndLastName.firstName,
        effectiveFirstAndLastName.lastName,
      ].filter(Boolean);
      return nameParts.join(" ");
    }
    return null;
  }, [showFullName, effectiveFirstAndLastName]);

  return {
    avatarClass,
    avatarStyleObj,
    style,
    imageSrc,
    imageAltText,
    contentStyle,
    avatarFaIcon,
    iconClassName,
    circleText,
    subText,
    rightSideContent,
  };
}

export default useAvatar;
